(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

/* Delegated listeners survive Focus/Horizon infinite scroll and filter replacements. */
(() => {
  if (window.__hbpPremiumCollectionInitialized) return;
  window.__hbpPremiumCollectionInitialized = true;
  const KEY = 'hbp-saved-products-v1';
  const storage = {
    read() { try { const value = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(value) ? value : []; } catch (_) { return []; } },
    write(value) { try { localStorage.setItem(KEY, JSON.stringify(value)); } catch (_) {} }
  };
  const escapeHTML = (value) => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function updateWishUI() {
    const saved = storage.read();
    const ids = new Set(saved.map(p => String(p.id)));
    document.querySelectorAll('.hbp-section [data-hbp-wish]').forEach(button => {
      const active = ids.has(button.dataset.productId);
      button.classList.toggle('is-saved', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('title', active ? 'Remove from wishlist' : 'Save to wishlist');
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Save ') + button.dataset.productTitle + (active ? ' from wishlist' : ' to wishlist'));
    });
    document.querySelectorAll('.hbp-section [data-hbp-saved-count]').forEach(node => { node.textContent = String(saved.length); });
    document.querySelectorAll('.hbp-section [data-hbp-saved-list]').forEach(list => {
      if (!saved.length) { list.innerHTML = '<p class="hbp-saved-empty">No saved products yet. Tap the heart on any product to save it here.</p>'; return; }
      list.innerHTML = saved.map(p => '<a class="hbp-saved-item" href="' + escapeHTML(p.url) + '">' + (p.image ? '<img loading="lazy" src="' + escapeHTML(p.image) + '" alt="">' : '') + '<span>' + escapeHTML(p.title) + '</span></a>').join('');
    });
  }
  function switchSlide(gallery, newIndex) {
    const track = gallery?.querySelector('[data-hbp-track]');
    if (!track) return;
    const count = track.querySelectorAll('[data-hbp-slide]').length;
    if (count <= 1) return;
    const index = ((newIndex % count) + count) % count;
    gallery.dataset.activeImage = String(index);
    track.style.transform = `translate3d(${-100 * index}%, 0, 0)`;
    gallery.querySelectorAll('[data-hbp-dot]').forEach((dot, i) => {
      dot.classList.toggle('is-current', i === index);
      dot.setAttribute('aria-current', String(i === index));
    });
  }
  function showToast(section, message, isError) {
    const toast = section?.querySelector('[data-hbp-toast]');
    if (!toast) return;
    const content = toast.querySelector('[data-hbp-toast-message]');
    content.textContent = message;
    toast.querySelector('[data-hbp-view-cart]').hidden = !!isError;
    toast.hidden = false;
  }
  document.addEventListener('click', (event) => {
    const prev = event.target.closest('.hbp-section [data-hbp-prev]');
    const next = event.target.closest('.hbp-section [data-hbp-next]');
    const dot = event.target.closest('.hbp-section [data-hbp-dot]');
    if (prev || next || dot) {
      event.preventDefault();
      const gallery = (prev || next || dot).closest('[data-hbp-gallery]');
      const active = Number(gallery?.dataset.activeImage || 0);
      switchSlide(gallery, dot ? Number(dot.dataset.hbpDot) : (prev ? active - 1 : active + 1));
      return;
    }
    const wish = event.target.closest('.hbp-section [data-hbp-wish]');
    if (wish) {
      const saved = storage.read();
      const id = wish.dataset.productId;
      const idx = saved.findIndex(p => String(p.id) === id);
      if (idx >= 0) saved.splice(idx, 1);
      else saved.push({ id, title:wish.dataset.productTitle, url:wish.dataset.productUrl, image:wish.dataset.productImage || '' });
      storage.write(saved);
      updateWishUI();
      return;
    }
    const savedOpen = event.target.closest('.hbp-section [data-hbp-saved-open]');
    if (savedOpen) {
      updateWishUI();
      const dialog = savedOpen.closest('.hbp-section').querySelector('[data-hbp-dialog]');
      if (dialog?.showModal) dialog.showModal();
      return;
    }
    const dialogClose = event.target.closest('.hbp-section [data-hbp-dialog-close]');
    if (dialogClose) { dialogClose.closest('dialog')?.close(); return; }
    const closeToast = event.target.closest('.hbp-section [data-hbp-close-toast]');
    if (closeToast) closeToast.closest('[data-hbp-toast]').hidden = true;
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.hbp-section [data-hbp-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const section = form.closest('.hbp-section');
    const original = button.textContent;
    const mode = form.dataset.cartMode;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Adding…';
    try {
      const response = await fetch(form.action.replace(/\/$/, '') + '.js', {
        method:'POST', body:new FormData(form), headers:{ 'Accept':'application/json' }, credentials:'same-origin'
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add product to cart');
      if (mode === 'redirect') { window.location.assign(section.dataset.cartUrl || '/cart'); return; }
      showToast(section, form.dataset.productTitle + ' added to your basket.', false);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true, detail:{ item:data } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles:true, detail:{ item:data } }));
      // Refresh common cart count indicators without depending on one theme's drawer implementation.
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const cartResponse = await fetch(root + 'cart.js', { credentials:'same-origin' });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count], [data-cart-count-text]').forEach(el => { el.textContent = String(cart.item_count); });
        }
      } catch (_) { /* Toast still offers an always-working cart link. */ }
    } catch (error) {
      showToast(section, error.message || 'Unable to add to basket. Please try again.', true);
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = original;
    }
  });
  // Keep saved states accurate when the theme replaces product cards after filtering / scrolling.
  const observer = new MutationObserver(mutations => {
    if (mutations.some(m => Array.from(m.addedNodes).some(n => n.nodeType === 1 && (n.matches?.('.hbp-section, [data-hbp-wish]') || n.querySelector?.('[data-hbp-wish]'))))) updateWishUI();
  });
  function init() {
    updateWishUI();
    observer.observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();

  } catch(e) { console.error(e); }
})();
})();
